export default __webpack_public_path__ + "static/media/customer-bg.35c87e62.webp";